import CaseStudiesSection from './components/CaseStudiesSection';
import ConnectSection from './components/ConnectSection';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import MotionDataSection from './components/MotionDataSection';
import PipelineIntegrationSection from './components/PipelineIntegrationSection';
import ProductsSection from './components/ProductsSection';
import StudioShowcaseSection from './components/StudioShowcaseSection';
import WorkflowsSection from './components/WorkflowsSection';

export default function HomePage() {
  return (
    <div className="flex flex-col [--vertical-spacing:64px] lg:[--vertical-spacing:112px]">
      <HeroSection />
      <IntroSection />
      <WorkflowsSection />
      <CaseStudiesSection />
      <ProductsSection />
      <MotionDataSection />
      <PipelineIntegrationSection />
      <StudioShowcaseSection />
      <ConnectSection />
    </div>
  );
}
